import React from 'react';
import { Stack } from '@mui/material';
import InconsistenciesWrapper, {
    InconsistenciesWrapperProps,
} from 'components/common/concierge-kg-control/InconsistenciesWrapper';
import { useStageGateConfig } from './StageGateContext';
import { useEditPanelBridge } from './EditPanelBridge';
import MoveBlockedBanner from './MoveBlockedBanner';

export default function IssuesTab({ issues, onOpenConcierge, objectType = 'report' }: InconsistenciesWrapperProps) {
    const gates = useStageGateConfig();
    const bridge = useEditPanelBridge();
    const moveBlock = bridge?.moveBlock ?? null;
    const inconsistenciesExpandToken = bridge?.inconsistenciesExpandToken ?? 0;
    const clarificationsExpandToken = bridge?.clarificationsExpandToken ?? 0;

    if (!issues.context) {
        return null;
    }
    return (
        <Stack spacing={2} sx={{ p: 3 }}>
            {moveBlock && <MoveBlockedBanner key={moveBlock.attempt} block={moveBlock} />}
            <InconsistenciesWrapper
                issues={issues}
                onOpenConcierge={onOpenConcierge}
                objectType={objectType}
                showInconsistencies={gates.showInconsistencies}
                showClarifications={gates.showClarifications}
                inconsistenciesExpandToken={inconsistenciesExpandToken > 0 ? inconsistenciesExpandToken : undefined}
                clarificationsExpandToken={clarificationsExpandToken > 0 ? clarificationsExpandToken : undefined}
            />
        </Stack>
    );
}
